import { useState } from "react";
import emailjs from "@emailjs/browser";
import "./RequestQuote.scss";
import { toast } from "react-toastify";

interface FormData {
  name: string;
  position: string;
  company: string;
  phone: string;
  email: string;
  message?: string;
}

const RequestQuote = () => {
  const [formData, setFormData] = useState<FormData>({
    name: "",
    position: "",
    company: "",
    phone: "",
    email: "",
    message: "",
  });
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 11);
    let value = digits;

    if (digits.length > 2) {
      value = `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    }
    if (digits.length > 7) {
      value = `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    }

    setFormData((current) => ({ ...current, phone: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setHasAttemptedSubmit(true);

    const phoneDigits = formData.phone.replace(/\D/g, "");
    const emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);

    if (
      !formData.name.trim() ||
      !formData.position.trim() ||
      !formData.company.trim() ||
      phoneDigits.length !== 11 ||
      !emailIsValid
    ) {
      toast.error("Revise os campos obrigatórios destacados antes de enviar.");
      return;
    }

    const data = {
      name: formData.name,
      position: formData.position,
      company: formData.company,
      phone: formData.phone,
      email: formData.email,
      message: formData.message
    }

    emailjs
      .send(
        "service_bbvydnd",
        "template_p3jdt0l",
        data,
        "oz45ERdEct62lUvwM"
      )
      .then(
        (result) => {
          toast.success("Mensagem enviada com sucesso! Em breve entraremos em contato.");

          setFormData({
            name: "",
            position: "",
            company: "",
            phone: "",
            email: "",
            message: "",
          });
          setHasAttemptedSubmit(false);
        },
        (error) => {
          toast.error("Não foi possível enviar sua mensagem. Tente novamente em instantes.");
        }
      );
  };

  return (
    <section className="requestQuotePage" id="talk-cta">
        <div className="requestQuotePage__intro" data-aos="fade-up">
          <span>Vamos conversar</span>
          <h1>Promova mais <br/>bem-estar para sua equipe</h1>
          <p>
            Conte um pouco sobre a sua empresa e descubra como a Sodalita pode
            criar uma experiência de bem-estar sob medida.
          </p>
        </div>
        <div className="requestQuotePage__form-wrapper" data-aos="fade-up">
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="contact-form__heading">
              <span>Fale com a nossa equipe</span>
              <h2>Entre em contato</h2>
              <p>Preencha os dados abaixo e retornaremos em breve.</p>
            </div>

            <div className={`form-group${hasAttemptedSubmit && !formData.name.trim() ? " form-group--invalid" : ""}`}>
              <label>Nome*</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className={`form-group${hasAttemptedSubmit && !formData.position.trim() ? " form-group--invalid" : ""}`}>
              <label>Cargo*</label>
              <input
                type="text"
                name="position"
                value={formData.position}
                onChange={handleChange}
                required
              />
            </div>

            <div className={`form-group${hasAttemptedSubmit && !formData.company.trim() ? " form-group--invalid" : ""}`}>
              <label>Empresa*</label>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
              />
            </div>

            <div className={`form-group${hasAttemptedSubmit && formData.phone.replace(/\D/g, "").length !== 11 ? " form-group--invalid" : ""}`}>
              <label>Telefone*</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handlePhoneChange}
                aria-invalid={hasAttemptedSubmit && formData.phone.replace(/\D/g, "").length !== 11}
                required
              />
              {hasAttemptedSubmit && formData.phone.replace(/\D/g, "").length !== 11 && (
                <span className="form-error">Informe um telefone válido.</span>
              )}
            </div>

            <div className={`form-group${hasAttemptedSubmit && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) ? " form-group--invalid" : ""}`}>
              <label>E-mail*</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                aria-invalid={hasAttemptedSubmit && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)}
                required
              />
              {hasAttemptedSubmit && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && (
                <span className="form-error">Informe um e-mail válido.</span>
              )}
            </div>

            <div className="form-group">
              <label>Mensagem (opcional)</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
              />
            </div>

            <button type="submit" className="submit-button" id="send-request-quote">
              Enviar Mensagem
            </button>
          </form>
        </div>
    </section>
  );
};

export default RequestQuote;
